// extracted by mini-css-extract-plugin
export default {"description":"BlockchainExplorer_description__njmLD"};